import React,{ Component} from "react";
import {Layout, Form, Input, Select,Button,message} from "antd";
import Header from "../../components/header";
import LeftQue from "../../components/leftQue";
import './ask.less'
import {reqAddTopic, reqCategory, reqUpload} from "../../api";
import { withRouter } from 'react-router';

const {Content} = Layout;
const {Option} = Select;
const {TextArea} = Input;

/**
 * 问题提问路由组件
 */
export class Ask extends Component {

    state = {
        list:[],
        imgList:[],
        inputCount:0,
    };

    imgClick =()=> {
        document.getElementById("upload").click();
    };

    inputImg =async(e)=> {
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        const result = await reqUpload(data);
        let arr = this.state.imgList;
        arr.push(result.data);
        this.setState({
            imgList:arr
        });
        const num = document.getElementsByClassName("img_num");
        if(num.length===4) {
            document.getElementsByClassName("upload_img")[0].style.display='none';
        }
    };

    deleteImg =(e,index)=> {
        let old = this.state.imgList;
        let arr = [];
        for (let i = 0; i < old.length; i++) {
            if(i!==index){
                arr.push(old[i]);
            }
        }
        if(arr.length<3){
            document.getElementsByClassName("upload_img")[0].style.display='block';
        }
        this.setState({
            imgList:arr
        });
    };
    textNumber = (e)=>{
        let length = e.target.value.length;
        if(length<31) {
            this.setState({
                inputCount: e.target.value.length
            })
        }else {
            this.setState({
                inputCount:30
            })
        }
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                values["imgs"] = this.state.imgList;
                // console.log('Received values of form: ', values);
                const result = await reqAddTopic(values);
                // console.log(result);
                if(result.code==='000000'){
                    message.success("提交成功");
                    this.props.history.replace("/question");
                }
            }
        });
    };

    componentDidMount = async () => {
        const result = await reqCategory("CASE");
        this.setState({
            list: result.data.rows,
        });
        document.getElementsByClassName("ant-menu-item")[1].click();
    };

    render() {
        const {list,imgList,inputCount} = this.state;
        const { getFieldDecorator } = this.props.form;
        let self = this;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftQue>LeftQue</LeftQue>
                    <Content>
                        <div className='ask_box'>
                            <Form className='ask_form' onSubmit={this.handleSubmit}>
                                <Form.Item  className={"categoryId"}>
                                    <span className={"star"}>*</span>
                                    <span className={"select_label"}>问题分类：</span>
                                    {getFieldDecorator('categoryId',{
                                        initialValue:1,
                                    })(
                                        <Select className="ask_select">
                                            {
                                                list&&list.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>

                                <Form.Item className="ask_title">
                                    <span className={"star"}>*</span>
                                    {getFieldDecorator('title', {
                                        rules: [
                                            { required: true, message: '请输入问题!'}
                                        ,{max:30,message: '问题不超过30个字'}],
                                    })(
                                        <Input placeholder={'请输入问题标题...'} maxLength={30} className="ask_input" onChange={(e)=>this.textNumber(e)}/>,

                                    )}
                                    <span className={"inputCount"}>{inputCount}/30</span>
                                </Form.Item>
                                <Form.Item className='context_border'>
                                    <span className={"star"}>*</span>
                                    {getFieldDecorator('message', {
                                        rules: [{ required: true, message: '请输入问题内容!' }]
                                    })(
                                        <TextArea placeholder={'请输入问题内容'} className="text_input" rows={10} >
                                        </TextArea>
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className='img_list'>
                                        <div className='img_box'>
                                            {
                                                imgList && imgList.map((item, index) => (
                                                    <div className='img_con' key={index}>
                                                        <img className='img_num' id={imgList[index]} src={global.constant.uploadImage+item}/>
                                                        <img className="img_delete" src={require('./images/del-img.png')} onClick={() => self.deleteImg(self,index)}/>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <img className='upload_img img_num' src={require('../../assets/images/upload_img.png')} onClick={this.imgClick.bind(this)}/>
                                        <Input className='upload_img' name="file" accept="image/*" id="upload" type="file" style={{opacity:0,display:'none'}} onChange={this.inputImg.bind(this)}/>
                                    </div>
                                </Form.Item>
                                <Form.Item >
                                    <Button type="primary" htmlType="submit">
                                        提交
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}
const WrapAsk = Form.create()(Ask);
export default WrapAsk;
withRouter(Ask);